import type { OrgRoutes } from '@src/types';

/**
 *
 * @param orgAuthorisedRoutes the routes the org of a user is authorised to view
 * @param staticPath the path the user is attempting to access, with any params
 * as static values, e.g. not: `/:region/:module/page`, but `/eu/boost/page`
 * @returns boolean value, if true the user is authorised, and not authorised if
 * false.
 */
export function isAuthorisedPathForUser(orgAuthorisedRoutes: OrgRoutes | null, staticPath: string): boolean {
  return (
    staticPath === '/' ||
    (orgAuthorisedRoutes?.findIndex(
      ({ route }) => route === staticPath || (route?.endsWith('/*') && staticPath.startsWith(route.slice(0, -2))),
    ) ?? -1) !== -1
  );
}
